import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { Progress } from 'components/ui/Progress';
import { useSurveyContext } from 'contexts/Survey';

const PERCENTAGE_SYMBOL = '%';

export interface QuestionProgressProps {
  showPercentage?: boolean;
  translationKey?: string;
}

export const QuestionProgress = ({
  showPercentage = true,
  translationKey = 'Survey.progress',
}: QuestionProgressProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  const { currentQuestionNumber, totalQuestions, surveyResponse } = useSurveyContext();

  const progress =
    totalQuestions === 0
      ? 0
      : Math.round(
          ((surveyResponse?.answers?.length ?? currentQuestionNumber - 1) / totalQuestions) * 100
        );

  return (
    <div className="flex flex-col gap-1 w-full items-center">
      <div className="flex items-center justify-between text-sm text-gray-600 w-full">
        <span>
          {t(translationKey, {
            current: currentQuestionNumber,
            total: totalQuestions,
          })}
        </span>
        {showPercentage && (
          <span>
            {progress}
            {PERCENTAGE_SYMBOL}
          </span>
        )}
      </div>
      <Progress value={progress} className="h-2 w-full" />
    </div>
  );
};
